import { shouldSkipTakingPage, shouldResetTakingRecords } from '../utils/takingListCache';

export const state = () => ({
  records: [],
  meta: {},
  fetching: false,
});

export const getters = {
  records(state) {
    return state.records;
  },
  meta(state) {
    return state.meta;
  },
  fetching(state) {
    return state.fetching;
  },
};

export const mutations = {
  SET_DATA(state, data) {
    state.records.push(...(data.data || []));
    state.meta = data.meta || {};
  },
  REPLACE_DATA(state, data) {
    state.records = [...(data.data || [])];
    state.meta = data.meta || {};
  },
  SET_FETCHING(state, fetching) {
    state.fetching = fetching;
  },
  RESET_DATA(state) {
    state.records = [];
    state.meta = {};
    state.fetching = false;
  },
};

export const actions = {
  fetch({ state, commit }, page = 1) {
    const loadedPage = state.meta.current_page || 0;
    if (shouldSkipTakingPage({ page, loadedPage, fetching: state.fetching })) {
      return Promise.resolve();
    }
    const replaceFirstPage = shouldResetTakingRecords(page);
    commit('SET_FETCHING', true);
    return this.$axios
      .$get('/api/orders', {
        params: { page },
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      })
      .then((resp) => {
        if (replaceFirstPage) {
          commit('REPLACE_DATA', resp);
        } else {
          commit('SET_DATA', resp);
        }
      })
      .finally(() => {
        commit('SET_FETCHING', false);
      });
  },
  refresh({ dispatch }) {
    return dispatch('fetch', 1);
  },
  clear({ commit }) {
    commit('RESET_DATA');
  },
};
